import React, { SyntheticEvent } from "react";
import { Button, Reveal } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../app/stores/store";
import { Profile } from "../../../app/models/Profile";
import { Game } from "../../../app/models/Game";
import { agent } from "../../../app/api/agent";
import { requestFirebaseNotificationPermission } from "../../../app/firebase/firebase-messaging";
import { useTranslation } from 'react-i18next'

interface Props{
    game:Game;
}

export default observer( function FollowButton({game}:Props){
    const { t } = useTranslation();
    const{gameStore} = useStore();
    const{updateGameFollowing, gameFollowingLoading} = gameStore;

    async function handleFollow(e: SyntheticEvent, id: string) {
      e.preventDefault();
      const wantsNotification = !game.isGameFollowing;
  
      // Only request token if enabling notifications
      if (wantsNotification) {
          try {
              // Check for existing token first
              let token = localStorage.getItem('fcmToken');
              
              if (!token) {
                  token = await requestFirebaseNotificationPermission();
                  if (token) {
                      localStorage.setItem('fcmToken', token);
                      await agent.Account.saveToken({ token });
                  }
              }
          } catch (error) {
              console.error('Failed to handle token:', error);
          }
      }
  
      game.isGameFollowing 
          ? updateGameFollowing({id, sendNotifications: false}) 
          : updateGameFollowing({id, sendNotifications: wantsNotification});
  }

    return(
        <Reveal animated="move">
            <Reveal.Content visible style={{ width: '100%' }}>
              <Button 
                fluid 
                color="teal" 
                content={game.isGameFollowing 
                  ? t('followButton.following') 
                  : t('followButton.notFollowing')
                } 
              />
            </Reveal.Content>

            <Reveal.Content hidden style={{ width: '100%' }}>
              <Button
                fluid
                color={game.isGameFollowing ? 'red' : 'green'}
                content={game.isGameFollowing 
                  ? t('followButton.unfollow') 
                  : t('followButton.follow')
                }
                loading = {gameFollowingLoading}
                onClick={(e) => handleFollow(e, game.id)} // Toggle follow state
              />
            </Reveal.Content>
          </Reveal>
    )
})